import {OverlayContainer} from '@angular/cdk/overlay';
import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DTFService } from './dtf.service';
import {APP_CONSTANTS} from './utils/app-constants';
import { TranslateUtil } from './utils/translate-util';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { SessionTimeoutComponent } from './components/sessionTimeout/sessionTimeout.component';
import { MatDialog } from '@angular/material/dialog';
import { WindowRef } from './utils/window';
import { AuthorizationService } from './components/authorization/authorization.service';
import { SharedTranslateModule } from './utils/sharedTranslateModule';
import { HeaderComponent } from './furniture/header.component';
import { FooterComponent } from './furniture/footer.component';
import { PasswordResetComponent } from './components/passwordreset/passwordreset.component';
import { PasswordResetConfirmComponent } from './components/passwordresetconfirm/passwordresetconfirm.component';
import { RegistrationPopupComponent } from './components/registrationPopup/registrationPopup.component';
import { VideoComponent } from './components/video/video.component';
import { FilterPipe } from './filter.pipe';
import { AlertPageComponent } from './furniture/alert.component';
import { MainNavLinksComponent } from './furniture/main-nav-links/main-nav-links.component';
import { MainNavComponent } from './furniture/main-nav/main-nav.component';


@Component({
    selector: '.mbfs-app',
    templateUrl: './app.component.html',
    imports: [
        SharedTranslateModule, HeaderComponent, FooterComponent,
    RouterOutlet,
    ],
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Zenith-P10';
  currentPath: String;
  private _window: WindowRef;

  idleState = 'Not started.';
  timedOut = false;
  countdown?: number = null;
  lastPing?: Date = null;

  targetRedirect = '';
  localRedirect = '';
  logoutRedirect = '';
  classicRedirect = '';
  isAuthenticated = false;
  isAdminAuthenticated = false;

  usUrl: string;
  caUrl: string;
  language = '';

  ngOnInit(): void {
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.auth.cast.subscribe(data => (this.isAuthenticated = data));
    this.auth.isAuthenticated(); // Checks if user is authenticated

    this.auth.castadmin.subscribe(data => (this.isAdminAuthenticated = data));
    this.auth.isAdminAuthenticated(); // Checks if user is authenticated
    // right when the component initializes, start reset state and start watching
      this.reset();
  }

  constructor( public translateUtil: TranslateUtil, public overlayContainer: OverlayContainer, 
    private idle: Idle, private keepalive: Keepalive, private cd: ChangeDetectorRef, public dialog: MatDialog,
    router: Router, window: WindowRef, public auth: AuthorizationService,) {
    this._window = window;
    this.translateUtil.setCountryAndLangFromUIProp();
    overlayContainer.getContainerElement().classList.add('light-theme');
    this.sessionTimeout();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started';
    this.timedOut = false;
  }

  sessionTimeout(){
    this.idle.setIdle(10);        // sets an idle timeout of 10 seconds, for testing purposes.

    this.idle.setTimeout(30*60);        // sets a timeout period of 30 seconds. after 10 seconds of inactivity, the user will be considered timed out.

    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);   // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document


    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No Longer Idle';
    });// this is the place to do somthing if user comes back after being idle.

      this.idle.onTimeout.subscribe(() => {
        if (this.isAuthenticated || this.isAdminAuthenticated){
        this.idleState = 'Timed out!';
        this.timedOut =true;
        let element:HTMLElement = document.getElementById('auto_trigger_logout') as HTMLElement;
        element.click();
       }
      });// this is place for redirect to login page.
  
      
      this.idle.onTimeoutWarning.subscribe(
        (countdown) => {
          if(countdown===(5*60)){
            if (this.isAuthenticated || this.isAdminAuthenticated){
            this.openDialog();}
          }
        this.idleState = 'You will time out in ' + countdown + 'seconds';
      }
      
      ); // this is the place for alert to notify of the logout 

    this.idle.onIdleStart.subscribe(() =>{
      this.idleState = 'You have gone Idle';
    }); // this is place to do somthing when user goes Idle.

    this.keepalive.interval(15);   // Sets the ping interval to 15 seconds

    
    this.keepalive.onPing.subscribe(() => {
      this.lastPing = new Date();
    });
    this.reset(); // this function start the whole ng Idle
  }

  openDialog() {
    this.dialog.open(SessionTimeoutComponent, {
      maxWidth: '200vw',
      width: '500px',
  });
  }

  onClickLogout(e: Event): void {
        if (this.language === 'en-CA') {
          this.logoutRedirect = this.usUrl + '/logout?lang=en-CA&country=CA';
        } else if (this.language === 'fr-CA') {
          this.logoutRedirect = this.usUrl + '/logout?lang=fr-CA&country=CA';
        } else {
          this.logoutRedirect = this.usUrl + '/logout?lang=en-US&country=US';
        }
      //}
      window.location.href = this.logoutRedirect;
    }
}

